import {default as animation} from './modules/_animation.js';

(function () {

	animation.init();

})();